/**
 * LeaderTile — «Ukas leder» på Hjem (#154).
 *
 * Toppen av ukas tavle (`useWeeklyLeaderboard`, rangert etter poeng), som
 * lenke til Tavle (`/leaderboard`). Som OpenChoresTile teller bare en leder
 * med poeng; ellers står «Ingen ennå». Kronen er pynt, navnet bærer
 * betydningen.
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components/primitives/Icon';
import { useWeeklyLeaderboard } from '../../leaderboard/useLeaderboardQueries';
import { MiniTile } from './MiniTile';

export function LeaderTile(): ReactNode {
  const { t } = useTranslation();
  const top = useWeeklyLeaderboard().data?.[0];
  const leader = top && top.points > 0 ? top.short_name : null;
  return (
    <MiniTile
      to="/leaderboard"
      label={t('home.leader.label')}
      data-testid="home-leader-tile"
      valueTestId="home-leader"
    >
      {leader ? (
        <span className="flex min-w-0 items-center gap-1.5 text-good">
          <Icon.Crown size={18} className="shrink-0 text-warn" />
          <span className="min-w-0 truncate">{leader}</span>
        </span>
      ) : (
        t('home.leader.empty')
      )}
    </MiniTile>
  );
}
